import { defineComponent, computed } from "vue";
import { getCommonLanguages, getOtherLanguages, unlimitedLanguageTip } from "@com/components/language-selector/util";
import { definePropType } from "@types-vue/props";
import { getFlagEmoji, flagsIconMapper } from "@com/config/ai-support-language";
export default defineComponent({
    props: {
        disabledSelect: {
            type: Boolean,
            default: false
        },
        language: [
            String,
            Array
        ],
        languageLists: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 自定义常用语言
        commonLanguages: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 项目来源
        type: {
            type: String,
            default: ""
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        // 将中文、英语、日语、韩语排在最前，剩余语言按首字母排序
        var languageModel = computed({
            get: function get() {
                return props.language;
            },
            set: function set(val) {
                emit("update:language", val);
            }
        });
        var commonLanguagesLists = computed(function() {
            return getCommonLanguages(props.languageLists, props.commonLanguages);
        });
        var otherLanguageLists = computed(function() {
            return getOtherLanguages(props.languageLists, props.commonLanguages);
        });
        var languageIcon = function(item) {
            var icon = "";
            // 视频项目
            if (props.type === "veditor") {
                // 获取国家,映射国旗
                var country = item.value && item.value.substring(item.value.indexOf("-") + 1).toLowerCase();
                icon = getFlagEmoji(country);
            } else {
                icon = flagsIconMapper[item.value] || "";
            }
            return icon + " " + item.label;
        };
        var languageTip = function(code) {
            return unlimitedLanguageTip[code] || "";
        };
        return {
            languageModel: languageModel,
            commonLanguagesLists: commonLanguagesLists,
            otherLanguageLists: otherLanguageLists,
            languageIcon: languageIcon,
            languageTip: languageTip
        };
    }
});
